export default [
  {
    key: 'increasement',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'lotteryName',
    label: 'field.lotteryName',
  },
  {
    key: 'lotteryTime',
    label: 'field.lotteryTime',
  },
  {
    key: 'post',
    label: 'field.channel',
  },
  {
    key: 'digit',
    label: 'field.digit',
  },
  {
    key: 'minWinAmount',
    label: 'field.minWinAmount',
  },
  // {
  //   key: 'maxWinAmount',
  //   label: 'field.maxWinAmount',
  // },
  {
    key: 'sellOutPer',
    label: 'field.sellOutPer',
  },
  {
    key: 'actions',
    label: 'field.actions',
  },
];
